'use client';

import type { ReactNode } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { AuthUIProvider } from '@daveyplate/better-auth-ui';

import { authClient } from '@/lib/auth-client';
import type { AuthSocialProviderId } from '@/lib/auth/config';

export function Providers({
  children,
  socialProviders,
}: {
  children: ReactNode;
  socialProviders: AuthSocialProviderId[];
}) {
  const router = useRouter();
  const { data: sessionContext } = authClient.useSession();
  const authUiProviderKey = [
    sessionContext?.user?.id ?? 'anonymous',
    sessionContext?.session?.impersonatedBy ?? 'self',
  ].join(':');

  return (
    <AuthUIProvider
      key={authUiProviderKey}
      avatar={true}
      authClient={authClient}
      navigate={router.push}
      replace={router.replace}
      onSessionChange={() => router.refresh()}
      Link={Link}
      social={socialProviders.length ? { providers: socialProviders } : undefined}
      nameRequired={false}
      deleteUser={true}
      signUp={{
        fields: [],
      }}
      organization={{
        basePath: '/settings/organization',
        logo: true,
      }}
      additionalFields={{
        timezone: {
          label: 'Timezone',
          type: 'string',
          required: false,
        },
      }}
      account={{
        basePath: '/settings',
        fields: ['image', 'name', 'email', 'timezone'],
        viewPaths: {
          SETTINGS: 'account',
        },
      }}
      localization={{
        YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS:
          'Only one organization is enabled in the free beta.',
        INVITATION_LIMIT_REACHED: 'Multiple team members are not supported in the free beta.',
        SIGN_UP_EMAIL: 'Almost there! Check your inbox to verify your email.',
        EMAIL_NOT_VERIFIED: 'Please check your inbox to verify your email.',
      }}
    >
      {children}
    </AuthUIProvider>
  );
}
